import { Component, input, signal } from '@angular/core';
import { ReleaseNote } from 'src/app/_models/release-note';
import { DatePipe } from '@angular/common';
import { CategoryComponent } from '../../chips/category/category.component';
import { IconButtonComponent } from '../../buttons/icon-button/icon-button.component';

@Component({
    selector: 'app-release-note',
    imports: [DatePipe, CategoryComponent, IconButtonComponent],
    templateUrl: './release-note.component.html',
    styleUrl: './release-note.component.scss'
})
export class ReleaseNoteComponent {
  /** The release note to display (required) */
  releaseNote = input<ReleaseNote>();

  /** Whether the expanded notes are hidden (optional, default: true) */
  hideNote = signal<boolean>(true);

  handleButtonClicked() {
    this.hideNote.update((v) => !v);
  }
}
